'use client';

import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { QueryApi } from '@/features/query/api';
import { ModalService } from '@/shared/ui/modal/ModalService';
import { SelectVenueModalContext } from './SelectVenueModalProvider';
import './styles.scss';

export const SelectVenueModalBottomPanel = () => {
    const t = useTranslations();
    const { isSignInVisible } = useContext(SelectVenueModalContext);
    const { data: isLoggedIn } = useQuery({
        ...QueryApi.Customer.queries.Customer,
        select: (data) => !!data,
    });

    if (!isSignInVisible || isLoggedIn) {
        return null;
    }

    const handleLogin = () => {
        ModalService.showPrefab('LoginModal', {});
    };

    return (
        <p>
            {t.rich('SELECT_VENUE_MODAL.LOGIN', {
                button: (chunk) => (
                    <button
                        type="button"
                        className="select-venue-modal__bottom__login-button"
                        onClick={handleLogin}
                    >
                        {chunk}
                    </button>
                ),
            })}
        </p>
    );
};
